import { useLocation } from "react-router-dom";
import { LastViewedProjects } from "./LastViewedProjects";
import { WorkFlowActions } from "./WorkFlowActions";
import { useGetPermissions } from "helpers/useGetPermissions";
import { allPermissions } from "App";
import { CSSProperties } from "react";
import { format, parseISO } from "date-fns";
import LastViewedProjectsCarousel from "./LastViewedProjectsCarousel";
import { APP_ROUTES, BASE_URL, DMS_PORTAL_URLS, HOST, endpoints } from "config";
import Page from "components/Page";
import Category from "components/Category";
import { InvoiceListData } from "pages/Invoices/InvoicesList.types";
import { getInvoicesEndpointsPermissions } from "pages/Invoices/InvoicesList.config";
import { formatInvoiceRow as invoicesRowFormatter } from "pages/Invoices/InvoicesList.formatters";
import Update from "assets/Icon_Action_02.png";
import Invoice from "pages/Invoices/Invoice";
import type { InvoiceActionType } from "pages/Invoices/Invoice/Invoice.types";
import { CrudItems, CrudOptions } from "components/Category/CrudMenu";

export interface HomeDashboardProps {}

export type Props = HomeDashboardProps;

const HomeDashboard: React.FC<Props> = (props) => {
  const permissions = useGetPermissions(allPermissions, useLocation());
  const lastViewedProjectListAccess = permissions.get("list-lastviewedprojects");
  const actionsApprovalListAccess = permissions.get("notifications-list");

  const parsedName = window.localStorage.getItem("FirstName") ?? "";

  return (
    <div
      style={{
        display: "flex",
        height: "calc(100vh - 61px)",
        position: "relative",
        overflowY: "auto", //opt
      }}
    >
      <div
        className="WidthContent HeightContent CategoryPage  "
        style={{ height: "auto", overflowY: "auto" }}
      >
        <h1 className="HomeHeader" data-testid="home-header">
          Hi {parsedName}
          {/* Hello {window.localStorage.getItem("ProfileInitials")} */}
        </h1>
        {lastViewedProjectListAccess && (
          <div data-testid="home-last-viewed">
            <LastViewedProjectsCarousel {...props} access={lastViewedProjectListAccess} />
          </div>
        )}
        {actionsApprovalListAccess && (
          <div data-testid="home-workflow">
            <WorkFlowActions {...props} access={actionsApprovalListAccess} />
          </div>
        )}
      </div>
    </div>
  );
};

export type DmsHomeDashboardProps = HomeDashboardProps;

const DmsHomeDashboard: React.FC<DmsHomeDashboardProps> = (props) => {
  const location = useLocation();
  const permissions = useGetPermissions(allPermissions, useLocation()); //'/home'
  const parsedName = window.localStorage.getItem("FirstName") ?? "";

  const endpointsPermissions = getInvoicesEndpointsPermissions("home");

  let hasInvoiceListPermissions = false;

  if (
    endpointsPermissions &&
    endpointsPermissions.list &&
    Array.isArray(endpointsPermissions.list)
  ) {
    endpointsPermissions.list.forEach((item: any) => {
      if (item.path === "home/list-dashboard") {
        hasInvoiceListPermissions = true;
      }
    });
  }

  console.log("endpointsPermissions: ", endpointsPermissions);

  const editPermissionsKey =
    endpointsPermissions && endpointsPermissions.edit
      ? endpointsPermissions.edit.toLowerCase()
      : "update";

  const editMenuCode =
    endpointsPermissions && endpointsPermissions.edit
      ? (endpointsPermissions.edit.toUpperCase().replace(/-/g, "_") as CrudOptions)
      : "UPDATE";

  console.log("editPermissionsKey: ", editPermissionsKey);
  console.log("editMenuCode: ", editMenuCode);

  const crudItems: CrudItems<InvoiceListData> = [
    {
      icon: Update,
      imgAltText: "Update",
      permissionsKey: editPermissionsKey,
      // permissionsKey: "edit",
      title: "Update invoice",
      menuCode: editMenuCode,
      showInMultiSelect: false,
      content: (onDone, selectedData, menu, additionalData, clickedIdIfMultiIds) => (
        <Invoice
          onDone={onDone}
          selectedData={selectedData}
          idFromRowOption={menu.selectedId}
          actionType={
            endpointsPermissions && endpointsPermissions.edit
              ? (endpointsPermissions.edit as InvoiceActionType)
              : ("update" as InvoiceActionType)
          }
          autoMenuActionsCode={
            endpointsPermissions && endpointsPermissions.edit
              ? (endpointsPermissions.edit.toUpperCase().replace(/-/g, "_") as CrudOptions)
              : "UPDATE"
          }
          clickedIdIfMultiIds={clickedIdIfMultiIds}
          homeModule={true}
        />
      ),
      inRightPanel: true,
      isDisabled: false,
    },
  ];

  return (
    <div
      className="DmsHomePage"
      style={{
        display: "flex",
        height: "calc(100vh - 61px)",
        position: "relative",
        overflowY: "auto", //opt
      }}
    >
      <div
        className="WidthContent HeightContent CategoryPage  "
        style={{ height: "auto", overflowY: "auto" }}
      >
        <h1 className="HomeHeader" data-testid="home-header">
          Hi {parsedName}
        </h1>

        {hasInvoiceListPermissions && (
          <div className="InvoicesSection CardListPage" data-testid="home-invoices">
            <Category<InvoiceListData>
              location={location}
              noun="invoice"
              idColumn={"invoices__Id"}
              disableAddButton={true} // Only want to update on this page
              listEndpointUrl={endpoints.home.listDashboard}
              // overridePermissionsPathName={APP_ROUTES.homedashboard}
              rowFormatter={invoicesRowFormatter}
              crudComponents={crudItems}
              hiddenColumns={["invoices__Id"]}
              hideHeaderTitle={false}
              overridePageTitle="Invoices"
              createPermissionsKey={"upload"}
              largeRightPanel={(menuCode) => menuCode !== "CREATE"}
              hideCardPage={true}
              cardProps={{
                cardTitleColumn: "invoices__FileName",
                cardLayout: 6,
                includeTypeColumn: false,
                cardActionType: "update",
                cardCustomContent: (data?: InvoiceListData) => (
                  <div className="InformationContainer">
                    <div className="MainInfo">
                      {data && data.invoices__SupplierName
                        ? data.invoices__SupplierName
                        : "No supplier name"}
                    </div>
                  </div>
                ),
                cardFooterButtonText: "Update invoice",
                cardContentClassname: "CardLayout4Container",
              }}
              rowCellOptions={{
                invoices__InvoicesCode: { width: "SemiLarge" },
                invoices__InvoicesName: { width: "SemiLarge3" },
                invoices__Description: { width: "Large" },
                invoices__HintText: { width: "SemiLarge3" },
                projects__ProjectsName: { width: "SemiLarge2" },
                roles__AssociatedRoleNames: { width: "Huge" },
                invoices__bTemplate: { width: "SemiLarge" },
                invoices__AddDate: { width: "Medium2" },
                invoices__AddedBy: { width: "Medium2" },
                invoices__EditDate: { width: "Medium2" },
                invoices__LastEditedBy: { width: "SemiLarge2" },
                //   invoices__Name: { width: "SemiLarge2" },
                //   invoices__Description: { width: "SemiLarge" },
                //   invoices__AddDate: { width: "Medium2" },
              }}
              maxCardPageTitleLength={30}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export type ContainerProps = HomeDashboardProps;

export const HomeDashboardContainer: React.FC<ContainerProps> = (props) => {
  let dmsPortal = false;

  if (DMS_PORTAL_URLS.includes(BASE_URL)) {
    dmsPortal = true;
  }

  return <Page>{!dmsPortal ? <HomeDashboard /> : <DmsHomeDashboard />}</Page>;
};

export default HomeDashboard;

export const ErrorSection = ({
  style,
  children,
}: {
  style?: CSSProperties | undefined;
  children?: any;
}) => {
  return (
    <div className="ErrorPage" style={style}>
      <div className="ErrorCell">
        <div className="Img">
          <img src={""} />
        </div>
        <div className="Txt">{children}</div>
      </div>
    </div>
  );
};
export const errTypeAndMsg = {
  generic: (
    <>
      <h1>Something went wrong</h1>
      <p>Please try again. If the error persists, please contact support.</p>
    </>
  ),
  noAccessPermission: (
    <>
      <h1>Something went wrong</h1>
      <p>You may not have access permissions</p>
    </>
  ),
};

export function formatDateString(inputDateString: string, targetFormat?: string) {
  const inputDate = parseISO(inputDateString);

  const formattedDate = format(inputDate, targetFormat ?? "dd - MMM - yyyy HH:mm:ss");

  return formattedDate;
}
